query Leads($input: LeadsInput!) {
  leads(input: $input) {
    total
  }
}
